import { useRef } from 'react';
var useLatest = function (value) {
    var ref = useRef(value);
    ref.current = value;
    return ref;
};
export default useLatest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useLatest.js
// module id = null
// module chunks = 